import React from 'react';
import { uuid } from 'uuidv4';

import "../App.css";

class Footer extends React.Component
{
	state = {
		socialMediaLinks: [
			{
				label: "Github",
				url: "https://github.com/TupLuisking",
				iconURL: "github.png",
			},
			{
				label: "Gitlab",
				url: "https://gitlab.com/Tuppy",
				iconURL: "gitlab.png",
			},
			{
				label: "Gamejolt",
				url: "https://gamejolt.com/@OneTupThree",
				iconURL: "gamejolt.png",
			},
			{
				label: "Fiverr",
				url: "https://www.fiverr.com/tupluisking",
				iconURL: "fiverr.png",
			}
		]
	};

	renderLink = (linkData) =>
	{
		return (

			<a
				key={uuid()}
				className='footer-link'
				href={linkData.url}
				target='_blank'
			>

				<img
					className='footer-link-img'
					src={require("../images/footer/" + linkData.iconURL)}
				/>

			</a>

		);
	}

	renderLinks = () =>
	{
		return (

			<React.Fragment>
				
				{this.state.socialMediaLinks.map((value, index) => (
					this.renderLink(value)
				))}
	
			</React.Fragment>
		);
	}

	render()
	{
		return (

			<div className='footer'>

				<div className='footer-email'>

					ramon.luisking14@gmail.com

				</div>

				<div className='footer-links'>

					{this.renderLinks()}

				</div>

			</div>

		);
	}
}

export default Footer;